import React from 'react';
import { Link } from 'react-router-dom';

import { SocialBar } from './SocialBar';

import './footer.less';

const Footer: React.StatelessComponent<{}> = (props) => {
  return (
    <footer className="site-footer">
      <div className="content">
        <div className="left">
          <a href="http://www.shawcontract.com/" target="_blank" className="brand scg-logo">Shaw Contract</a>
          <SocialBar />
          <div className="copyright">
            <span className="line">&copy; Copyright {new Date().getFullYear()}, Shaw, A Berkshire Hathaway Company</span>
          </div>
        </div>
        <div className="right">
          <div className="about">
            <ul className="links">
              <li><Link to="/help">Need Assistance?</Link></li>
              <li><Link to="/help">Privacy &amp; Terms of Use</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
